export default __webpack_public_path__ + "img/53636c22ea10516fdb69116f66fd26f0.svg";